import { render, staticRenderFns } from "./AppHead.vue?vue&type=template&id=a674b520&scoped=true&"
import script from "./AppHead.vue?vue&type=script&lang=ts&"
export * from "./AppHead.vue?vue&type=script&lang=ts&"
import style0 from "./AppHead.vue?vue&type=style&index=0&id=a674b520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a674b520",
  null
  
)

component.options.__file = "AppHead.vue"
export default component.exports